import request from "root/js/request";

export const getWBDynamicSubjects = async ({
  date_from,
  date_to,
  period,
  extra_fields = "id",
  ...rest
} = {}) => {
  const response = await request({
    url: `wb_dynamic/subjects/`,
    method: "get",
    params: {
      date_from,
      date_to,
      period,
      extra_fields,
      ...rest,
    },
  });
  return response.data;
};
